import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-huoyuanguanli",
  "use": "icon-icon-huoyuanguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-huoyuanguanli\"><defs><style type=\"text/css\"></style></defs><path d=\"M957.1 643.1L934 496.6c-1.4-49.5-39.9-89.4-86.9-89.4h-11.5L793.4 318c-9.9-20.9-29.7-33.8-51.7-33.8H584.6v-30.8c0-33.9-25.8-61.5-57.4-61.5h-402c-31.7 0-57.4 27.6-57.4 61.5v90h159v61.5h-159v61.5h187.8v61.5H67.8v186.9H158c12.8 52.9 57.4 92.2 110.8 92.2s97.9-39.3 110.8-92.2h266.6C659 767.7 703.6 807 756.9 807c53.4 0 97.9-39.3 110.8-92.2h32.4c17.1 0 33.3-8 44.3-22 10.9-13.8 15.5-31.9 12.7-49.7zM268.8 745.5c-31.7 0-57.4-27.6-57.4-61.5s25.8-61.5 57.4-61.5c31.7 0 57.4 27.6 57.4 61.5s-25.8 61.5-57.4 61.5z m488.1 0c-31.7 0-57.4-27.6-57.4-61.5s25.8-61.5 57.4-61.5 57.4 27.6 57.4 61.5c0.1 33.9-25.7 61.5-57.4 61.5z\" fill=\"#ffffff\" p-id=\"8569\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-huoyuanguanli.svg
// module id = Yzci
// module chunks = 29